import convertToArray from './convertToArray';

class LoginCorporationInfo {
  init() {
    this.doc = document;
    this.radioBtns = convertToArray(this.doc.querySelectorAll('[name="corporation"]'));
    this.radioBtnsLength = this.radioBtns.length;
    this.targetHiddenClass = 'is_hidden';
    this.formItems = convertToArray(this.target.querySelectorAll('input, select'));
    this.formItemsLength = this.formItems.length;
  }
  start() {
    this.target = document.getElementById('registrationForm-corporationWrapper');
    if (!this.target) return;
    this.init();
    for (let ri = 0; ri < this.radioBtnsLength; ri += 1) {
      const radio = this.radioBtns[ri];
      radio.addEventListener('change', () => {
        if (radio.value === '法人登記あり') {
          this.showFunc();
        } else {
          this.hideFunc();
        }
      }, false);
    }
  }
  showFunc() {
    this.target.classList.remove(this.targetHiddenClass);
    for (let fi = 0; fi < this.formItemsLength; fi += 1) {
      this.formItems[fi].disabled = false;
    }
  }
  hideFunc() {
    this.target.classList.add(this.targetHiddenClass);
    for (let fi = 0; fi < this.formItemsLength; fi += 1) {
      this.formItems[fi].disabled = true;
    }
  }
}
export default LoginCorporationInfo;



// WEBPACK FOOTER //
// ./src/js/module/LoginCorporationInfo.js